// extracted by mini-css-extract-plugin
module.exports = {"verifiedOld":"verified-badge_verifiedOld__9kS0i","verifiedBlue":"verified-badge_verifiedBlue__jC9bB","verifiedGovernment":"verified-badge_verifiedGovernment__0JECA"};